import { CollapseItem } from './CollapseItem';

export function DetailTable({ detailTables, colors, fonts, applyVariable }) {
  return detailTables.map((detailTable, index) => {
    return <CollapseItem key={detailTable.id} detailTable={detailTable} colors={colors} fonts={fonts} applyVariable={applyVariable} index={index} />;
  });
}
